var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.parsed),function(block,i){return _c('p',{key:i,staticClass:"tokens-block"},_vm._l((block),function(cluster,j){return _c('base-token',{key:("block-" + i + "-cluster-" + j),class:{
        'font-italic outlined-match':
          _vm.selected &&
          cluster.match &&
          cluster.match.filter(function (e) { return _vm.selected.includes(e.concept.conceptid); })
            .length > 0
      },attrs:{"value":cluster.token,"matches":cluster.match,"data-ids":cluster.match &&
          cluster.match.map(function (e) { return ((e.concept.conceptid) + ";"); }).join('')},nativeOn:{"click":function($event){return _vm.select(cluster.match)}}})}),1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }